import React from 'react'
import PropTypes from 'prop-types'

const ViewContainer = (props) => {
  const { children } = props
  return (
    <div className="view-container">
      { children }
    </div>
  )
}

ViewContainer.propTypes = { children: PropTypes.node.isRequired }

export default ViewContainer
